import { ExtractArrayType } from '@prophecy/interfaces/generic';
import { FROZEN_EMPTY_ARRAY } from '@prophecy/utils/constants';

import { useGraphQlQuery } from '../data/util';
import { QueryKeys } from './queries/common';
import { UserTeamsQuery } from './queries/team';

export function useUserTeamsFromUid(uid?: string, enabled = true) {
  const variables = { uid: uid || '' };
  const { data: teamData, ...rest } = useGraphQlQuery(
    [QueryKeys.User, QueryKeys.TeamList, variables],
    UserTeamsQuery,
    { enabled: Boolean(uid) && enabled },
    variables
  );

  const teams = teamData?.User?.teams;
  const defaultTeams = FROZEN_EMPTY_ARRAY as ExtractArrayType<NonNullable<typeof teams>>[];
  return { data: teams || defaultTeams, ...rest };
}
